import { RelatedConceptModel } from './related-concept.model';
import { MonitoringKeywordGroupModel } from './monitoring-keyword-group.model';
import { RelatedConceptsResponseModel } from '../../../api/mercury/model/related-concepts-response.model';
import { operatorsEnum } from '../enums/operators.enum';


export class RelatedConceptsModel {

    themes: RelatedConceptModel[];
    people: RelatedConceptModel[];
    companies: RelatedConceptModel[];

    constructor(apiModel?: RelatedConceptsResponseModel) {

        if (apiModel) {
            this.constructFromApi(apiModel);
        } else {
            this.constructDefault();
        }
    }

    constructFromApi(apiModel: RelatedConceptsResponseModel) {
        this.themes = apiModel.themes.map(x => new RelatedConceptModel(x));
        this.people = apiModel.people.map(x => new RelatedConceptModel(x));
        this.companies = apiModel.companies.map(x => new RelatedConceptModel(x));
    }

    constructDefault() {
        this.themes = [];
        this.people = [];
        this.companies = [];
    }

    /**
     * Determines if any concept has been selected
     */
    anyConceptSelected(): boolean {
        const selectedConcept =
            this.themes.some(concept => concept.selected && !concept.disabled) ||
            this.people.some(concept => concept.selected && !concept.disabled) ||
            this.companies.some(concept => concept.selected && !concept.disabled);

        return selectedConcept;
    }

    /**
     * disable any concepts that has been selected
     */
    disableSelectedConcepts() {
        this.themes.forEach(concept => {
            if (concept.selected && !concept.disabled) {
                concept.disabled = true;
            }
        });

        this.people.forEach(concept => {
            if (concept.selected && !concept.disabled) {
                concept.disabled = true;
            }
        });

        this.companies.forEach(concept => {
            if (concept.selected && !concept.disabled) {
                concept.disabled = true;
            }
        });
    }


    /**
     * Update concepts to properly reflect the state of the keywords.
     * When concepts have been added, then removed from the keywords, add them back to the concepts list
     */
    updateConcepts(keywordGroup: MonitoringKeywordGroupModel) {
        if (!keywordGroup || !keywordGroup.isAnyKeywordSet()) {

            return;
        }

        const keywords = [...keywordGroup.or, ...keywordGroup.and, ...keywordGroup.not];

        this.themes.forEach(concept => {
            if (!keywords.includes(concept.value) && concept.disabled) {
                concept.disabled = false;
                concept.selected = false;
            }
        });

        this.people.forEach(concept => {
            if (!keywords.includes(concept.value) && concept.disabled) {
                concept.disabled = false;
                concept.selected = false;
            }
        });

        this.companies.forEach(concept => {
            if (!keywords.includes(concept.value) && concept.disabled) {
                concept.disabled = false;
                concept.selected = false;
            }
        });
    }

    convertToKeywordGroup(): MonitoringKeywordGroupModel {
        const keywordGroup = new MonitoringKeywordGroupModel();

        const allRelatedConcepts: RelatedConceptModel[] = [
            ...this.themes,
            ...this.people,
            ...this.companies
        ];

        keywordGroup.and = allRelatedConcepts
            .filter(concept => concept.selected && !concept.disabled && concept.type === operatorsEnum.and)
            .map(concept => concept.value);

        keywordGroup.or = allRelatedConcepts
            .filter(concept => concept.selected && !concept.disabled && concept.type === operatorsEnum.or)
            .map(concept => concept.value);

        keywordGroup.not = allRelatedConcepts
            .filter(concept => concept.selected && !concept.disabled && concept.type === operatorsEnum.not)
            .map(concept => concept.value);

        return keywordGroup;
    }
}
